import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { getVaultAPYDisplay } from 'structure/pv2/vault/utils/vault';
import { Body2 } from 'components/Typography';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { formatPercent } from '@dapp/multi-lib/lib/formatters';
import * as React from 'react';

export const VaultAPY = (props: { vault: DynaVault; className?: string }) => {
  const { vault, className } = props;

  const {
    value: apy,
    prefix: apyPrefix,
    isAvailable,
  } = getVaultAPYDisplay(vault);
  const _apy = isAvailable ? formatPercent(apy.toString()) + '%' : '-';

  return (
    <Body2
      className={twMerge(
        cx(
          'text-white',
          {
            'text-green': apy > 0,
            'text-white': apy <= 0,
          },
          className
        )
      )}
    >
      {apyPrefix}
      {_apy}
    </Body2>
  );
};
